import { Shield, Gem, Palette, Clock, Leaf, Pencil } from "lucide-react";
import { useTranslation } from "react-i18next";

const icons = [Shield, Gem, Palette, Clock, Leaf, Pencil];

const BenefitsSection = () => {
  const { t } = useTranslation();
  const items = t("benefits.items", { returnObjects: true }) as { title: string; desc: string }[];

  return (
    <section className="py-12 md:py-20 lg:py-28 bg-secondary">
      <div className="container mx-auto px-4">
        <div className="text-center mb-8 md:mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground mb-3 md:mb-4">{t("benefits.title")}</h2>
          <p className="text-muted-foreground text-sm md:text-lg max-w-2xl mx-auto">{t("benefits.subtitle")}</p>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-6">
          {items.map((b, i) => {
            const Icon = icons[i];
            return (
              <div key={i} className="bg-card rounded-xl p-4 md:p-8 shadow-navy/5 shadow-lg hover:shadow-xl transition-shadow border border-border group">
                <div className="w-10 h-10 md:w-14 md:h-14 rounded-xl gradient-gold flex items-center justify-center mb-3 md:mb-5 group-hover:scale-110 transition-transform">
                  <Icon className="w-4 h-4 md:w-6 md:h-6 text-accent-foreground" />
                </div>
                <h3 className="text-sm md:text-xl font-semibold text-foreground mb-1 md:mb-2">{b.title}</h3>
                <p className="text-muted-foreground text-xs md:text-base leading-relaxed">{b.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default BenefitsSection;
